/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { Jx3Search } from './types/jx3';

export const getSearch = ({ type, kw, offset, limit }) => http.get<Jx3Search[]>(`jx3/search-data/${type}`, { q: kw, offset, limit });
export const getAutocomplete = ({ type, kw }) => http.get<string[]>(`jx3/search-suggest/${type}`, { q: kw });
